import * as React from "react";
function SvgIcChevronSmallUp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.62 13.501L12 10.866l-4.62 2.635-.38-.65L12 10l5 2.851-.38.65z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcChevronSmallUp;
